var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmailmin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 110,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.22 41.592l.011 60.966c0 2.737-1.425 5.172-4.033 5.172l-95.045.081c-2.608 0-4.15-1.531-4.15-4.267l.024-61.963",
    stroke: "url(#prefix__paint0_linear_7142_44918)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.072 76.754L2.375 42.74a1.346 1.346 0 01.116-1.971L47.208 3.693c1.182-1.09 3.35-1.681 4.926-1.681L54.394 2c1.588 0 3.767.603 4.961 1.705l45.378 36.96c.603.498.661 1.414.104 1.971l-33.08 34.13",
    stroke: "url(#prefix__paint1_linear_7142_44918)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.908 106.466l35.908-31.892a10.304 10.304 0 016.549-2.377l16.03-.012c2.365 0 4.66.812 6.491 2.308l35.711 31.15",
    stroke: "url(#prefix__paint2_linear_7142_44918)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.179 70.132l-6.943 6.298-3.837-2.529a10.393 10.393 0 00-5.726-1.716H44.3c-2.052 0-4.057.603-5.76 1.74l-3.78 2.505-7.163-7.446-4.219-4.395V15.487h59.75v49.554l-4.948 5.091z",
    fill: "#fff",
    stroke: "url(#prefix__paint3_linear_7142_44918)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.43 61.992c-3.118 1.646-6.306 2.273-10.107 2.273-9.32 0-17.213-6.82-17.213-17.732 0-11.702 8.126-21.826 20.725-21.826 9.887 0 16.528 6.935 16.528 16.421 0 8.524-4.775 13.523-10.107 13.523-2.272 0-4.37-1.531-4.207-4.999-1.983 3.352-4.822 4.998-8.23 4.998-3.292 0-6.131-2.667-6.131-7.155 0-7.05 5.563-13.464 13.456-13.464 2.446 0 4.602.51 6.074 1.194l-1.936 10.287c-.846 4.314-.173 6.309 1.704 6.367 2.898.058 6.132-3.804 6.132-10.403 0-8.234-4.938-14.148-13.747-14.148-9.26 0-17.038 7.33-17.038 18.868 0 9.487 6.19 15.343 14.592 15.343 3.234 0 6.248-.684 8.578-1.995l.927 2.448zM58.3 37.44c-.568-.174-1.53-.395-2.84-.395-4.995 0-9.029 4.72-9.029 10.229 0 2.505 1.252 4.314 3.744 4.314 3.292 0 6.306-4.21 6.931-7.724l1.194-6.424z",
    fill: "url(#prefix__paint4_linear_7142_44918)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear_7142_44918",
    x1: 2.004,
    y1: 41.581,
    x2: 106.142,
    y2: 43.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear_7142_44918",
    x1: 2,
    y1: 2,
    x2: 106.137,
    y2: 3.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint2_linear_7142_44918",
    x1: 2.908,
    y1: 72.185,
    x2: 104.435,
    y2: 74.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint3_linear_7142_44918",
    x1: 23.377,
    y1: 15.487,
    x2: 83.662,
    y2: 16.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint4_linear_7142_44918",
    x1: 34.11,
    y1: 24.707,
    x2: 71.697,
    y2: 25.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D83B95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailmin);
export default __webpack_public_path__ + "static/media/icon-email.min.8b4e627e9efe69393f2cb8a17024bedc.svg";
export { ForwardRef as ReactComponent };